import { Textarea as Textarea_ } from "@chakra-ui/react";
import { forwardRef } from "react";
export const Textarea = forwardRef(({ ...props }, ref) => {
    return <Textarea_ ref={ref} {...props}>{props?.children}</Textarea_>
});